import {ScreenState} from "../core/models/categories/screen-state.model";
import {Relation} from "../core/models/entities/entity/relation.model";
import {Column} from "../core/models/entities/column.model";
import {PaginationOptions} from "../core/models/entities/pagiantion-options.model";
import {Toolbar} from "ngx-editor";

export const generalState: ScreenState = {
  id: 0,
  name: 'General View',
}

export const generalRelation: Relation = {
  name: "general",
  label: "General Information",
  position: -1,
  permissions: []
}

export const richTextToolbar: Toolbar = [
  ['bold', 'italic'],
  ['ordered_list', 'bullet_list'],
  [{heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']}],
  ['text_color', 'background_color'],
  ['align_left', 'align_center', 'align_right', 'align_justify'],
  ['indent', 'outdent'],
];


export const actionColumns: Column[] = [
  {id: -1, position: -1, name: 'tick_marker', text: 'tick_marker', width: 36, is_sticky: true},
  {id: -2, position: -2, name: 'checkbox', text: 'checkbox', width: 27, is_sticky: true},
  {id: -3, position: -3, name: 'show_icon', text: 'show_icon', width: 27, is_sticky: true},
  {id: -4, position: -4, name: 'inline_edit', text: 'inline_edit', width: 27, is_sticky: true}
]

export const USER_TOKEN = 'user_token'
export const USER_PERMISSIONS = 'user_permissions_by_entity'
export const CURRENT_USER = 'current_user'
export const AUDIT_OVERLAY_ARROW_PADDING = 35;
export const TABLE__CUSTOM_ROWS_COUNT = 4;
export const TABLE_SPACER_ROW_ID = -1;
export const TABLE_SUM_ROW_ID = -2;
export const TABLE_SELECTED_SUM_ROW_ID = -3;
/** Action columns prepended for reports (tick marker, checkbox). */
export const REPORT_ACTION_COLUMNS_COUNT = 2;
export const TABLE__DEFAULT_PER_PAGE = 50;
export const SIGN_OUT = 'sign-out'
export const CLASSIFIER_VALUE_KEY = 'value'
export const DEFAULT_COLUMN_WIDTH_MIN = 50;
export const DEFAULT_COLUMN_WIDTH_MAX = 400;
export let DEFAULT_COLUMN_WIDTH = 130;

export function setDefaultColumnWidth(width: number): void {
  if (Number.isInteger(width) && width >= DEFAULT_COLUMN_WIDTH_MIN && width <= DEFAULT_COLUMN_WIDTH_MAX) {
    DEFAULT_COLUMN_WIDTH = width;
  }
}

export const DEFAULT_PAGINATION: PaginationOptions = {page: 1, per_page: 50, search_term: ''};
export const RULE_UNIQUE = 'unique'
export const MAX_TIMEOUT = 2_147_483_647; // Max setTimeout value (~24.8 days)
export const TOKEN_EXPIRY_BUFFER_MS = 100_000;
export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
};
